import { Container, Heading, Stack, Text } from "@chakra-ui/react";
import Gallery from "./Gallery";
export default function Highlight() {
  return (
    <Container maxW={"8xl"}>
      <Stack
        textAlign={"center"}
        align={"center"}
        spacing={{ base: 8, md: 10 }}
        py={{ base: 15, md: 20 }}
      >
        <Heading
          fontWeight={600}
          fontSize={{ base: "3xl", sm: "4xl", md: "6xl" }}
          lineHeight={"110%"}
        >
          <Text as={"span"} color={"orange.400"}>
            FESTIN
          </Text>
          <Text as={"span"} color={"blue.400"}>
            -
          </Text>
          <Text
            as={"span"}
            style={{ WebkitTextStroke: "3px #4299E1" }}
            color={"white"}
          >
            O
          </Text>
          <Text as={"span"} color={"blue.400"}>
            -
          </Text>
          <Text as={"span"} color={"green.400"}>
            Beats &nbsp;
          </Text>
          <br />
          <Text
            as={"span"}
            style={{ WebkitTextStroke: "3px #4299E1" }}
            color={"white"}
          >
            Highlights
          </Text>
        </Heading>
        <Text color={"gray.500"} maxW={"3xl"} >
          Here's a glimpse of all the major events which are going to take place
          at the hottest fest ever!!
        </Text>
        <Gallery />
      </Stack>

    </Container>
  );
}
